import { render, staticRenderFns } from "./OurMission.vue?vue&type=template&id=1fa12c60&scoped=true"
import script from "./OurMission.vue?vue&type=script&lang=js"
export * from "./OurMission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa12c60",
  null
  
)

export default component.exports